module.exports = __webpack_public_path__ + "img/sunrise_1.7f4d196a.png";